import Container from '@/components/Container';
import { Fragment, useEffect, useState } from 'react';
import { Transition } from '@headlessui/react';
import { deleteCookie, setCookie } from 'cookies-next';
import cookiesConstants from '@/constants/cookies.constants';
import CustomPagination from '@/components/skus/searchCustom/CustomPagination';
import SellerMobileBidsDisplay from './SellerMobileBidsDisplay';
import { AllSortsCustomTranslated } from '@/types/other';
import { FilterConfig } from '@/types/props/components/skus';
import SkusMobileSearchFilters from '../../SkusMobile/SkusMobileSearchCustom/SkusMobileSearchFilters';
import SkusMobileSearchShowFilters from '../../SkusMobile/SkusMobileSearchCustom/SkusMobileSearchShowFilters/SkusMobileSearchShowFilters';

interface SellerMobileProps {
  allSortsCustomTranslated: AllSortsCustomTranslated[];
  hasFilterCookie: boolean;
  asks: any[];
  onCardClick: (e: React.MouseEvent<HTMLElement, MouseEvent>, sku: any, groupedAsks?: any) => void;
  sellerName: string;
  maxBottles?: number;
}

export default function SellerMobile({
  allSortsCustomTranslated,
  hasFilterCookie,
  asks,
  onCardClick,
  sellerName,
  maxBottles,
}: SellerMobileProps) {
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
  const [filtersAreOpen, setFiltersAreOpen] = useState<boolean>(hasFilterCookie);

  // Filter configuration for seller page - disable status filter
  const filterConfig: FilterConfig = {
    status: false, // Hide status filter on seller page
    category: true,
    brand: true,
    price: true,
    country: true,
    region: true,
    size: true,
  };

  useEffect(() => {
    if (filtersAreOpen) {
      setCookie(cookiesConstants.COOKIES.FILTERS_ARE_OPEN.name, 'true');
    } else {
      deleteCookie(cookiesConstants.COOKIES.FILTERS_ARE_OPEN.name);
    }

    return () => {
      deleteCookie(cookiesConstants.COOKIES.FILTERS_ARE_OPEN.name);
    };
  }, [filtersAreOpen]);

  return (
    <>
      <Transition
        as={Fragment}
        show={filtersAreOpen}
        enter="transition-opacity duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-300"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        unmount={false}
      >
        <Container>
          <div className="tw-py-8">
            <SkusMobileSearchShowFilters
              setFiltersAreOpen={setFiltersAreOpen}
              filtersAreOpen={filtersAreOpen}
              filterConfig={filterConfig}
            />
          </div>
        </Container>
      </Transition>
      <Transition
        as={Fragment}
        show={filtersAreOpen === false}
        enter="transition-opacity duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-300"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        unmount={false}
      >
        <Container className="tw-pb-8">
          <div className="tw-py-8">
            <SkusMobileSearchFilters
              viewMode={viewMode}
              setViewMode={setViewMode}
              allSortsCustomTranslated={allSortsCustomTranslated}
              setFiltersAreOpen={setFiltersAreOpen}
              filterConfig={filterConfig}
            />
          </div>

          <SellerMobileBidsDisplay
            viewMode={viewMode}
            asks={asks}
            onCardClick={onCardClick}
            maxBottles={maxBottles}
          />

          <CustomPagination />
        </Container>
      </Transition>
    </>
  );
}
